import Api from "@src/api";
import { KEY } from "../../constants/common.const";
export const EquipmentMasterApi= {
  getTree(params) {
    return Api().get("MachineClassificationMaster",{params});
  },
  getEquipmentCateById(id) {
    return Api().get("MachineClassificationMaster/" + id);
  },
  updateEquipmentCate(data) {
    return Api().put("MachineClassificationMaster", data);
  },
  createEquipmentCate(data) {
    return Api().post("MachineClassificationMaster", data);
  },
  deleteEquipmentCate(id) {
    return Api().delete("MachineClassificationMaster/" + id);
  },
};
